/* Light YouTube Embeds by @labnol */
/* Web: http://labnol.org/?p=27941 */

// lazy-load youtube videos
document.addEventListener("DOMContentLoaded",
	function () {

		/* === Performance: Auto lazy-load below-fold images === */
		/* Collection/product description table images and other content images */
		document.querySelectorAll('.rte table img, .rte td img, .collection-description img').forEach(function(img) {
			if (!img.hasAttribute('loading')) {
				img.setAttribute('loading', 'lazy');
				img.setAttribute('decoding', 'async');
			}
		});

		// Youtube
		var div, n, v = document.getElementsByClassName("youtube-player");
		for (n = 0; n < v.length; n++) {
			div = document.createElement("div");
			div.setAttribute("data-id", v[n].dataset.id);
			div.innerHTML = youtubeThumb(v[n].dataset.id);
			div.onclick = youtubeIframe;
			v[n].appendChild(div);
		}
  
  		// Vimeo
		var v2 = document.getElementsByClassName("lazy-vimeo-player");
		for (n = 0; n < v2.length; n++) {
            var vimeoId = v2[n].dataset.id;
			var vimeoPreviewDiv = document.createElement("div");
			vimeoPreviewDiv.setAttribute("data-id", vimeoId);
            vimeoPreviewDiv.onclick = vimeoIframe;
          	var vimeoThumb = document.createElement("img");
            vimeoThumb.setAttribute("loading","lazy");
            vimeoThumb.setAttribute("width",640);
            vimeoThumb.setAttribute("height",360);
            vimeoThumb.setAttribute("alt","Product Video");
          	vimeoThumb.setAttribute("data-vimeo-id",vimeoId);
            vimeoThumb.setAttribute("src","");
            vimeoPreviewDiv.appendChild(vimeoThumb);
          	//vimeoPreviewDiv.onclick = vimeoIframe;
          	v2[n].appendChild(vimeoPreviewDiv);
          
            var imgThumb = v2[n].dataset.thumb;
            if (typeof imgThumb != "undefined"){
              vimeoThumb.setAttribute("src",imgThumb);
            } 
            else {
              $.getJSON('https://vimeo.com/api/oembed.json?url=https%3A//vimeo.com/' + vimeoId, {
                format: "json",
                width: "640"
              },
              function(data) {
                $("img[data-vimeo-id=" + data.video_id + "]").attr('src', data.thumbnail_url_with_play_button);
              });
            }
		}

        // add green bullets
      /*
        $('ul.fa-ul li').each(function () {
          $(this).html('<i class="fa-li fa fa-check-circle"></i>' + $(this).html());
    	});
      */
        /* link title hover suppression REMOVED — harmed accessibility and added event listeners to every <a> tag */

      // hook up tsg accordion
      document.querySelectorAll(".tsg-question").forEach(question => {
        question.addEventListener("click", function() {
          const answer = this.nextElementSibling;
          const isOpen = answer.style.display === "block";
    
          // Close all answers before opening a new one (optional)
          document.querySelectorAll(".tsg-answer").forEach(a => a.style.display = "none");
          
          // Toggle the current answer
          answer.style.display = isOpen ? "none" : "block";
          
          // Remove active class from all the other questions
          document.querySelectorAll(".tsg-question").forEach(a => a.classList.remove("active"));
          if (!isOpen){
            // Toggle active class for styling
            this.classList.toggle("active");
            }
        });
      });

      
	});

function youtubeThumb(id) {
	var thumb = '<img src="https://i.ytimg.com/vi/ID/hqdefault.jpg">',
		play = '<div class="play"></div>';
	return thumb.replace("ID", id) + play;
}

function youtubeIframe() {
	var iframe = document.createElement("iframe");
	var embed = "https://www.youtube.com/embed/ID?rel=0&amp;showinfo=0";
	iframe.setAttribute("src", embed.replace("ID", this.dataset.id));
	iframe.setAttribute("frameborder", "0");
	iframe.setAttribute("allowfullscreen", "1");
	this.parentNode.replaceChild(iframe, this);
}

function vimeoThumb(id) {
	var vimeoVideoInfoURL = "https://vimeo.com/api/oembed.json?url=http%3A//vimeo.com/" + id;
    var imgSrc;
	$.ajax({
		type: 'GET',
		url: vimeoVideoInfoURL,
		dataType: "json",
		success: function (data) {
            imgSrc = data.thumbnail_url_with_play_button;
		}
	});
  	return imgSrc;
}

function vimeoIframe() {
    var iframeContainer = document.createElement("div");
    iframeContainer.setAttribute("class", "vimeo-video-container");
  
	var iframe = document.createElement("iframe");
	var embed = "//player.vimeo.com/video/ID?autoplay=1&amp;loop=1&amp;";
    iframe.setAttribute("width", "640");
    iframe.setAttribute("height", "360");
	iframe.setAttribute("src", embed.replace("ID", this.dataset.id));
	iframe.setAttribute("frameborder", "0");
	iframe.setAttribute("allowfullscreen", "1");
    iframe.setAttribute("allow","autoplay; fullscreen");
	
    iframeContainer.appendChild(iframe);
    this.parentNode.replaceChild(iframeContainer, this);
}

// lazy-load vimeo videos
/*
$(document).ready(function () {
	$('div.lazy_vimeo').each(function () {
		var id = $(this).data('vimeo-id'),
			iframe = $('<iframe width="640" height="360" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen />');
		iframe.attr('src', "//player.vimeo.com/video/" + id + "?portrait=0&amp;badge=0&amp;color=a3cd3a");
		$(this).replaceWith(iframe);
	});
});
*/


function scrollToTabs() {
  //document.getElementById('productDescription').scrollIntoView();
   window.scrollBy({ top: 500, left: 0, behavior: 'smooth' });
}
/* =====================================================
   TSG Product Page Animations (v2 pages only)
   Scoped to .tsg-v2 wrapper — will not affect existing pages
   ===================================================== */
(function() {
  if (!('IntersectionObserver' in window)) return;
  /* Only initialize if a .tsg-v2 wrapper exists on this page */
  function hasTsgV2() { return !!document.querySelector('.tsg-v2'); }

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('tsg-visible');
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.15,
    rootMargin: '0px 0px -40px 0px'
  });

  function initReveals() {
    if (!hasTsgV2()) return;
    document.querySelectorAll('.tsg-v2 .tsg-reveal, .tsg-v2 .tsg-reveal--left, .tsg-v2 .tsg-reveal--right, .tsg-v2 .tsg-reveal--scale, .tsg-v2 .tsg-stagger').forEach(function(el) {
      observer.observe(el);
    });
  }

  /* Animated counter for stat numbers */
  var counterObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        animateCounter(entry.target);
        counterObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.5 });

  function animateCounter(el) {
    var target = parseFloat(el.getAttribute('data-count'));
    var suffix = el.getAttribute('data-suffix') || '';
    var prefix = el.getAttribute('data-prefix') || '';
    var duration = 1200;
    var start = 0;
    var startTime = null;

    function step(timestamp) {
      if (!startTime) startTime = timestamp;
      var progress = Math.min((timestamp - startTime) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      var current = Math.round(start + (target - start) * eased);
      if (target % 1 !== 0) {
        current = (start + (target - start) * eased).toFixed(1);
      }
      el.textContent = prefix + current.toLocaleString() + suffix;
      if (progress < 1) {
        window.requestAnimationFrame(step);
      }
    }
    window.requestAnimationFrame(step);
  }

  function initCounters() {
    if (!hasTsgV2()) return;
    document.querySelectorAll('.tsg-v2 [data-count]').forEach(function(el) {
      counterObserver.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { initReveals(); initCounters(); 

  // New-style accordion (tsg-accordion-trigger / tsg-accordion-content)
  document.querySelectorAll(".tsg-accordion-trigger").forEach(trigger => {
    trigger.addEventListener("click", function() {
      const item = this.closest(".tsg-accordion-item");
      const content = item.querySelector(".tsg-accordion-content");
      const isOpen = item.classList.contains("active");
      
      // Close all
      document.querySelectorAll(".tsg-accordion-item").forEach(i => {
        i.classList.remove("active");
        i.querySelector(".tsg-accordion-trigger")?.classList.remove("active");
      });
      
      // Toggle current
      if (!isOpen) {
        item.classList.add("active");
        this.classList.add("active");
      }
    });
  });
});
  } else {
    initReveals();
    initCounters();
  }
})();
